import React from 'react';
import { ColorRing } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';

interface Props {
  isDraggable: boolean;
  isLoading: boolean;
  objectSlug: string;
  handleSavePosition: () => void;
  handleToggleDraggable: () => void;
}

const PopupButtonsArea: React.FC<Props> = ({
  isDraggable,
  isLoading,
  objectSlug,
  handleSavePosition,
  handleToggleDraggable,
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'PopupButtonsArea' });
  return (
    <div className="d-flex align-items-center justify-content-between mx-2 font-poppins">
      {isDraggable ? (
        <button
          className={`btn btn-ghost-success mt-2 d-flex align-items-center gap-2 ${isLoading ? 'pe-none' : ''}`}
          onClick={handleSavePosition}
        >
          {isLoading && (
            <ColorRing
              visible
              height="20"
              width="20"
              ariaLabel="color-ring-loading"
              wrapperStyle={{}}
              wrapperClass="color-ring-wrapper"
              colors={['#9C7AE2', '#E27A8C', '#C0E27A', '#7AE2D0', '#F7F18F']}
            />
          )}
          <span>{t('save')}</span>
        </button>
      ) : (
        <button className="btn btn-ghost-success mt-2" onClick={handleToggleDraggable}>
          {t('changePosition')}
        </button>
      )}
      <a href={`/r/object/traps/${objectSlug}`} type="button" className="mt-2 btn btn-ghost-success">
        {t('details')}
      </a>
    </div>
  );
};

export default PopupButtonsArea;
